import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { Directive, ElementRef, Input, forwardRef, HostListener } from '@angular/core';
import { MAT_LEGACY_INPUT_VALUE_ACCESSOR as MAT_INPUT_VALUE_ACCESSOR } from '@angular/material/legacy-input';

@Directive({
  selector: 'input[matInputInteger]',
  exportAs: 'matInputInteger',
  providers: [
    {provide: MAT_INPUT_VALUE_ACCESSOR, useExisting: MatInputIntegerDirective},
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MatInputIntegerDirective),
      multi: true,
    }
  ]
})
export class MatInputIntegerDirective implements ControlValueAccessor {

  private _value: string | null;

  constructor(private elementRef: ElementRef<HTMLInputElement>,
  ) {
  }


  get value(): string | null {
    return this._value;
  }

  @Input('value')
  set value(value: string | null) {
    this._value = value;
  }



  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    // If pattern doesn't match, we reset the value of input to the previous valid value.
    // set cleaned value on native input element
    if (!this.checkInputValid(value)) {
      this.elementRef.nativeElement.value = this._value;
      return;
    }
    this._value = value;
    this._onChange(this._value); // here to notify Angular Validators
  }

  @HostListener('blur')
  _onBlur() {
  }

  _onChange(value: any): void {
  }


  writeValue(value: any) {
    // check input and set only valid value
    if (this.checkInputValid(value)) {
      this._value = value;
      this.elementRef.nativeElement.value = this._value;
    }
  }

  registerOnChange(fn: (value: any) => void) {
    this._onChange = fn;
  }

  registerOnTouched() {
  }

  // Check for valid chars in valid order. Minus allowed to enter negative numbers.
  private checkInputValid(value: string): boolean {
    if (value != null && value.length > 0 && !value.match(/^[-]?\d*$/)) {
      return false;
    }
    return true;
  }
}
